<template>
  <div
    class="image-zoom"
    @wheel="handleWheel"
    @dragend="stopDrag"
    @drag="drag"
    v-if="imageViewURL != null && imageViewURL != ''"
  >
    <img :src="imageViewURL" :style="imageStyle" ref="image" />
  </div>
</template>

<script>
import {ref, computed} from 'vue';
export default {
  name: 'MsImage',
  props: {
    imageViewURL: {
      default: null,
      type: [String],
    },
  },
  emits: [],

  setup(props) {
    const scale = ref(1);
    const minScale = 1; // Giới hạn tối thiểu
    const maxScale = 3; // Giới hạn tối đa

    const imageStyle = computed(() => ({
      transform: `scale(${scale.value})`,
      transition: 'transform 0.2s',
      cursor: dragging.value ? 'grabbing' : 'grab',
      // Thay đổi góc nhìn dựa trên vị trí con trỏ chuột
      transformOrigin: 'top left',
    }));

    const dragging = ref(false);
    const lastMousePosition = ref({x: 0, y: 0});
    const image = ref(null);

    const handleWheel = event => {
      event.preventDefault();
      const zoomFactor = 0.1;

      // Tính toán vị trí chuột trong hình ảnh
      const rect = image.value.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      const scaleBefore = scale.value;

      // Zoom in or out
      if (event.deltaY < 0) {
        scale.value = Math.min(maxScale, scale.value + zoomFactor);
      } else {
        scale.value = Math.max(minScale, scale.value - zoomFactor);
      }

      const scaleDiff = scale.value - scaleBefore;

      // Cập nhật vị trí hình ảnh dựa trên tỷ lệ zoom
      const newOffsetX = (mouseX * scaleDiff) / scaleBefore;
      const newOffsetY = (mouseY * scaleDiff) / scaleBefore;

      // Thay đổi vị trí hình ảnh
      if (image.value) {
        const currentTransform = image.value.style.transform;
        const translateMatch = currentTransform.match(/translate\((-?\d+)px,\s*(-?\d+)px\)/);
        const translateX = translateMatch ? parseFloat(translateMatch[1]) : 0;
        const translateY = translateMatch ? parseFloat(translateMatch[2]) : 0;

        image.value.style.transform = `scale(${scale.value}) translate(${translateX - newOffsetX}px, ${
          translateY - newOffsetY
        }px)`;
      }
    };

    const stopDrag = () => {
      dragging.value = false;
    };

    const drag = event => {
      if (scale.value === 1) return;
      dragging.value = true;
      const deltaX = event.clientX - lastMousePosition.value.x;
      const deltaY = event.clientY - lastMousePosition.value.y;

      if (image.value) {
        const currentTransform = image.value.style.transform;
        const translateMatch = currentTransform.match(/translate\((-?\d+)px,\s*(-?\d+)px\)/);
        const translateX = translateMatch ? parseFloat(translateMatch[1]) : 0;
        const translateY = translateMatch ? parseFloat(translateMatch[2]) : 0;

        image.value.style.transform = `scale(${scale.value}) translate(${translateX + deltaX}px, ${
          translateY + deltaY
        }px)`;
      }

      lastMousePosition.value = {x: event.clientX, y: event.clientY};
    };

    return {
      scale,
      imageStyle,
      handleWheel,
      stopDrag,
      drag,
      image,
    };
  },
};
</script>

<style scoped lang="scss">
.image-zoom {
  overflow: auto;
  padding: 8px 16px;
  background-color: white;
  img {
    display: block;
    width: auto;
    max-height: 100%;
    max-width: 100%;
    transform-origin: top left;
  }
}
</style>